export const BUTTON_ACTION = {
  SUBMIT: 'submit',
  OPEN_LINK: 'open_link',
  FILL_DATA: 'fill_data',
};

export const CTA_POSITIONS = ['first_cta', 'second_cta'];
